export  class StringHelpers{

  private static readonly ACCENTED = 'àâäçéèêëîïôöùûüÿñœæ';
  private static readonly PLAIN = 'aaaceeeeiiouuuynoa';

  // Doit rester aligne sur SearchNormalization cote C# : le filtrage local et le filtrage
  // serveur doivent normaliser de la meme facon, sinon l'un trouve ce que l'autre rate.
  public static NormalizeForSearch(value: string | null | undefined): string {
    if (!value) return '';

    const lowered = value.toLowerCase();
    let normalized = '';

    for (const character of lowered) {
      const index = StringHelpers.ACCENTED.indexOf(character);
      normalized += index >= 0 ? StringHelpers.PLAIN[index] : character;
    }

    return normalized;
  }

  public static Pluralize(word: string): string {
    try {
      let pluralSuffix = word.toLowerCase().endsWith('s')?'es':'s' 
      let pluralized =  word.endsWith('y') ? word.slice(0, -1) + 'ies' : `${word}${pluralSuffix}`;

      return pluralized; 

    } catch (e) {
      throw new Error(`==> [Pluralize] - Error due to word format ${word}`);
    }
   
  }
  
 public static Humanize(str: string): string {
    try {
      const humanized = str.replace(/([a-z])([A-Z])/g, '$1 $2');

      return humanized.charAt(0).toUpperCase() + humanized.slice(1).toLowerCase();
    } catch (e) {
      console.error(`==> [Humanize] - Error due to string format ${str}`);
      return ''; 
    }
  }
}
